export default __webpack_public_path__ + "static/wheat-icon-83dc489668551b650ef05613ab7d3e92.svg";